"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportListRequest = void 0;
var SupportListRequest = /** @class */ (function () {
    function SupportListRequest() {
    }
    return SupportListRequest;
}());
exports.SupportListRequest = SupportListRequest;
;
//# sourceMappingURL=supportList.request.js.map